import { MinusIcon, PlusIcon } from 'lucide-react';
type Props = {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  /** Waar het getal over gaat, voor schermlezers: "Sessies gehad". */
  label: string;
};
const btn = 'flex h-9 w-9 items-center justify-center rounded-full border border-line text-ink transition-colors duration-150 ease-soft hover:border-ink disabled:opacity-30 sm:h-8 sm:w-8';

/** Min en plus rond een getal — overal in het beheer dezelfde maat. */
export function Stepper({
  value,
  onChange,
  min = 0,
  max = 99,
  label
}: Props) {
  return <span className="flex shrink-0 items-center gap-1.5" role="group" aria-label={label} data-id="element-5515" data-mp="3hjpkijf1zk71">
      <button type="button" onClick={() => onChange(value - 1)} disabled={value <= min} aria-label={`${label}: één minder`} className={btn} data-id="element-5516" data-mp="32qx77yn60li3">
        <MinusIcon className="h-3.5 w-3.5" strokeWidth={2} aria-hidden="true" data-id="element-5517" data-mp="2ts1wqad38p8z" />
      </button>
      <span className="w-6 text-center text-[14px] tabular-nums text-ink" aria-live="polite" data-id="element-5518" data-mp="2yrwn8csybcti">
        {value}
      </span>
      <button type="button" onClick={() => onChange(value + 1)} disabled={value >= max} aria-label={`${label}: één meer`} className={btn} data-id="element-5519" data-mp="5cdj0ot1p34l">
        <PlusIcon className="h-3.5 w-3.5" strokeWidth={2} aria-hidden="true" data-id="element-5520" data-mp="1efs9hjmm8z3" />
      </button>
    </span>;
}